const ja = {
	form: {
		transactionTime: '取引日時',
		websiteName: 'Webサイト',
		all: '全て',
		group: 'グループ',
		logisticsCompany: '物流会社',
		uploadStatus: 'アップロードステータス',
		transactionId: 'サイト注文番号',
		trackingNumber: '物流注文番号',
		logisticsCompanyURL: '追跡URL',
		uploaded: 'アップロードされました',
		not_uploaded: '未アップロード',
		noLimited: '制限なし',
		logisticsNumber: '物流注文番号',
		goodsName: '商品名',
		logisticsCompanyName: '物流会社名'
	},
	warning: {
		start: '現在あなたも持っています',
		end: 'この注文については注文情報がアップロードされていません。決済に影響を与えないように、できるだけ早くアップロードしてください。'
	},
	button: {
		search: '検索',
		reset: 'リセット',
		upload: '一括アップロード情報',
		download: 'バッチテンプレートをダウンロードする',
		export: '現在の結果をエクスポートする',
		modify: '改訂',
		uploadByOne: 'アップロード',
		cancel: 'キャンセル',
		confirm: '確認'
	},
	table: {
		orderidAndWebsiteName: 'サイト注文番号 / Webサイト',
		transactionTime: '取引日時',
		uploadStatus: 'アップロードステータス',
		goodsName: '商品名',
		orderidAndCompany: '追跡番号 / 配送業者',
		logisticsCompanyURL: '追跡URL',
		uploadTime: '更新日時',
		operation: '操作',
		modify: '改訂',
		uploadByOne: 'アップロード',
		uploaded: 'アップロードされました',
		notUploaded: '未アップロード'
	},
	alert: {
		uploadTip: 'まず「現在の結果をエクスポート」をクリックして、物流情報を追加してアップロードしてください',
		coverTip: 'ファイルには注文番号と物流情報が含まれています。本当にカバーされていますか？',
		excTip: 'ファイル内の以下の販売者注文番号に対応するフィールド情報に異常があるため、残りの注文情報がアップロードされました。',
		notExit: 'ファイル内の次の販売者注文番号が存在しないか、物流情報をアップロードする必要がありません。残りの注文情報がアップロードされました。',
		moreTip: 'ファイルのアップロードに失敗しました。以下の加盟店注文番号に対応するフィールド情報を修正した後、ファイルを再アップロードしてください。',
		moreNotExit: 'ファイル内に多数の販売者注文番号が存在しないか、物流情報をアップロードする必要がありません。確認して再度アップロードしてください。',
		upload: '物流情報のアップロード',
		modify: '物流情報の変更',
		uploading: 'データはアップロード中です。Web ページを更新せずにお待ちください。'
	},
	message: {
		fieldRequired: '必須項目です',
		downloadFailed: 'ネットワークエラーのため、ダウンロードに失敗しました',
		uploadFailed: 'アップロードに失敗しました',
		uploadSuccess: 'アップロードに成功しました'
	},
	autoUpload: {
		intro: 'ECプラットフォームと連携することで、物流情報を自動的にアップロードできます。',
		support: '<b class="red">*</b> 現在は <b class="blue">Shopify/WooCommerce/Shoplazza</b> ユーザーの自動同期のみに対応しています。その他のユーザーは単件または一括でアップロードしてください。',
		schedule: '<b class="red">*</b> 物流情報は毎日24:00（UTC+0）に自動同期されます。',
		guideTitle: '操作手順',
		step1Title: 'ステップ1',
		step1Content: '<b class="blue">【サイト管理】</b> ページを開きます',
		step2Title: 'ステップ2',
		step2Content: '<i class="el-icon-link blue"></i> マークのあるサイトを見つけ、右側の <i class="iconfont blue">&#xe6a0;</i> ボタンをクリックし、<b class="blue">物流連携</b> を選択します。',
		step3Title: 'ステップ3',
		step3Content: '情報を入力して【確認】をクリックすると、連携が完了します。'
	}
}
export default ja
